// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cir-","colBig":"styles_colBig__2j67t","colSmall":"styles_colSmall__Qeiwy","shopifyNameWrapper":"styles_shopifyNameWrapper__3n7D4"};